var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHydrant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M409.916,238.89c4.722,0,8.551,3.829,8.551,8.551v34.205c0,4.722-3.829,8.551-8.551,8.551h-34.205 V238.89L409.916,238.89L409.916,238.89z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB9D2"
    },
    d: "M375.716,290.205h34.205c4.722,0,8.551-3.829,8.551-8.551v-17.102h-42.756V290.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB9D2"
    },
    d: "M102.079,238.898c-4.722,0-8.551,3.829-8.551,8.551v34.205c0,4.722,3.829,8.551,8.551,8.551h34.205 v-51.307H102.079z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#959CB5"
    },
    d: "M136.284,290.205h-34.205c-4.722,0-8.551-3.829-8.551-8.551v-17.102h42.756V290.205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C7CFE2"
    },
    d: "M264.551,8.017h-17.102c-4.722,0-8.551,3.829-8.551,8.551v34.205h34.205V16.568 C273.102,11.845,269.274,8.017,264.551,8.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AFB9D2"
    },
    d: "M264.551,8.017h-17.102c-4.722,0-8.551,3.829-8.551,8.551v34.205H256V16.568 C256,11.845,259.829,8.017,264.551,8.017z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C84146"
    },
    d: "M370.519,318.608c7.994-1.599,13.748-8.618,13.748-16.77v-74.572c0-8.152-5.754-15.172-13.748-16.77 l-29.008-5.803v119.716L370.519,318.608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5050"
    },
    d: "M256,42.221L256,42.221c-51.949,0-94.063,42.113-94.063,94.063v350.597h188.125V136.284 C350.063,84.335,307.949,42.221,256,42.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5383D"
    },
    d: "M141.481,210.494c-7.994,1.599-13.748,8.618-13.748,16.77v74.572c0,8.152,5.754,15.172,13.748,16.77 l29.008,5.803V204.693L141.481,210.494z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C84146"
    },
    d: "M268.268,205.921c-12.412-2.481-24.298-1.09-34.724,3.153c-5.625,2.289-11.747-1.794-11.747-7.865 v-64.926c0-41.473,26.875-76.604,64.134-89.117c-16.173-5.432-34.21-6.8-53.111-2.029c-42.217,10.657-70.88,50.046-70.88,93.587 v348.156h59.858V327.903c0-6.112,6.173-10.134,11.838-7.839c6.907,2.798,14.454,4.345,22.367,4.345 c36.938,0,66.062-33.458,58.718-71.722C310.244,229.382,291.538,210.574,268.268,205.921z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C84146"
    },
    d: "M392.818,503.983H119.182c-4.722,0-8.551-3.829-8.551-8.551V478.33c0-4.722,3.829-8.551,8.551-8.551 h273.637c4.722,0,8.551,3.829,8.551,8.551v17.102C401.37,500.155,397.541,503.983,392.818,503.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C84146"
    },
    d: "M367.165,170.489h-222.33c-4.722,0-8.551-3.829-8.551-8.551v-17.102 c0-4.722,3.829-8.551,8.551-8.551h222.33c4.722,0,8.551,3.829,8.551,8.551v17.102C375.716,166.66,371.887,170.489,367.165,170.489z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5383D"
    },
    d: "M213.244,161.937v-17.102c0-4.722,3.829-8.551,8.551-8.551h-76.96c-4.722,0-8.551,3.829-8.551,8.551 v17.102c0,4.722,3.829,8.551,8.551,8.551h76.96C217.073,170.489,213.244,166.66,213.244,161.937z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B5383D"
    },
    d: "M213.244,495.432V478.33c0-4.722,3.829-8.551,8.551-8.551H119.182c-4.722,0-8.551,3.829-8.551,8.551 v17.102c0,4.722,3.829,8.551,8.551,8.551h102.614C217.073,503.983,213.244,500.155,213.244,495.432z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B5383D"
    },
    cx: 256,
    cy: 264.551,
    r: 42.756
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C7CFE2"
    },
    cx: 256,
    cy: 264.551,
    r: 25.653
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256,196.676c-37.426,0-67.875,30.449-67.875,67.875s30.449,67.875,67.875,67.875s67.875-30.449,67.875-67.875 S293.426,196.676,256,196.676z M256,316.392c-28.585,0-51.841-23.256-51.841-51.841c0-28.585,23.256-51.841,51.841-51.841 s51.841,23.256,51.841,51.841S284.585,316.392,256,316.392z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M279.902,252.233c-4.362,0.758-7.283,4.908-6.526,9.271c0.173,0.997,0.261,2.022,0.261,3.047 c0,9.725-7.912,17.637-17.637,17.637s-17.637-7.912-17.637-17.637c0-9.725,7.912-17.637,17.637-17.637 c0.99,0,1.982,0.082,2.951,0.245c4.371,0.734,8.499-2.217,9.23-6.583s-2.216-8.499-6.583-9.23c-1.841-0.309-3.724-0.465-5.598-0.465 c-18.566,0-33.67,15.105-33.67,33.67s15.105,33.67,33.67,33.67c18.566,0,33.67-15.105,33.67-33.67c0-1.942-0.168-3.891-0.498-5.791 C288.415,254.397,284.268,251.475,279.902,252.233z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M409.921,230.881h-17.637v-4.284c0-11.547-7.824-21.568-19.027-24.369l-15.177-3.795v-19.928h9.086 c9.136,0,16.568-7.432,16.568-16.568v-17.102c0-9.136-7.432-16.568-16.568-16.568h-9.4c-3.439-44.056-34.969-80.347-76.646-90.932 V16.568C281.119,7.432,273.687,0,264.551,0h-17.102c-9.136,0-16.568,7.432-16.568,16.568v20.768 c-41.677,10.585-73.207,46.876-76.646,90.932h-9.4c-9.136,0-16.568,7.432-16.568,16.568v17.102c0,9.136,7.432,16.568,16.568,16.568 h9.086v19.928l-15.177,3.795c-11.203,2.801-19.027,12.821-19.027,24.369v4.284h-17.637c-9.136,0-16.568,7.432-16.568,16.568v34.205 c0,9.136,7.432,16.568,16.568,16.568h17.637v4.284c0,11.547,7.824,21.568,19.027,24.369l15.177,3.795v131.093h-34.739 c-9.136,0-16.568,7.432-16.568,16.568v17.102c0,9.136,7.432,16.568,16.568,16.568h273.637c9.136,0,16.568-7.432,16.568-16.568 V478.33c0-9.136-7.432-16.568-16.568-16.568h-34.739V330.669l15.177-3.795c11.203-2.8,19.027-12.821,19.027-24.369v-4.284h17.637 c9.136,0,16.568-7.432,16.568-16.568v-34.205C426.489,238.313,419.057,230.881,409.921,230.881z M246.914,16.568 c0-0.295,0.239-0.534,0.534-0.534h17.102c0.295,0,0.534,0.239,0.534,0.534v18.046c-2.994-0.265-6.023-0.409-9.086-0.409 s-6.092,0.143-9.086,0.409V16.568z M144.301,161.937v-17.102c0-0.295,0.239-0.534,0.534-0.534H281.65 c4.427,0,8.017-3.589,8.017-8.017c0-4.427-3.589-8.017-8.017-8.017H170.341c4.059-43.7,40.918-78.029,85.659-78.029 s81.602,34.33,85.659,78.029H315.86c-4.427,0-8.017,3.589-8.017,8.017c0,4.427,3.589,8.017,8.017,8.017h51.305 c0.295,0,0.534,0.239,0.534,0.534v17.102c0,0.295-0.239,0.534-0.534,0.534h-222.33C144.54,162.472,144.301,162.232,144.301,161.937z  M102.079,282.188c-0.295,0-0.534-0.239-0.534-0.534v-34.205c0-0.295,0.239-0.534,0.534-0.534h17.637v35.273H102.079z  M142.631,311.32c-4.052-1.013-6.882-4.638-6.882-8.814v-75.909c0-4.176,2.829-7.801,6.882-8.814l11.29-2.822v99.182L142.631,311.32 z M315.856,461.762c-4.427,0-8.017,3.589-8.017,8.017s3.589,8.017,8.017,8.017h76.962c0.295,0,0.534,0.239,0.534,0.534v17.102 c0,0.295-0.239,0.534-0.534,0.534H119.182c-0.295,0-0.534-0.239-0.534-0.534V478.33c0-0.295,0.239-0.534,0.534-0.534h162.472 c4.427,0,8.017-3.589,8.017-8.017s-3.589-8.017-8.017-8.017H169.954V178.505h172.092v283.257H315.856z M376.251,302.505 c0,4.176-2.829,7.801-6.882,8.814l-11.29,2.822V214.96l11.29,2.822c4.052,1.013,6.882,4.638,6.882,8.814V302.505z M410.455,281.653 c0,0.295-0.239,0.534-0.534,0.534h-17.637v-35.273h17.637c0.295,0,0.534,0.239,0.534,0.534V281.653z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydrant);
export default __webpack_public_path__ + "static/media/hydrant.aae29fd7ccd6cb1d96324511bdeca5a6.svg";
export { ForwardRef as ReactComponent };